export const OAUTH_LOGIN_STATE_KEY = 'TokenLoginState';

/**
 * Helper function to handle writing the oauth redirect state to localStorage.
 * Required to avoid safari bug where redux won't persist the state to localStorage
 * before redirecting to the oauth url
 *
 * @param state - the state to persist
 */
export function writeOauthStateToLocalStorage(state?: string): void {
  if (state) {
    localStorage.setItem(OAUTH_LOGIN_STATE_KEY, state);
  }
}
